import { createContext, ReactNode, useContext } from 'react';

export type PremiumPageIconColor = 'brand' | 'indigo' | 'emerald' | 'violet' | 'amber' | 'rose' | 'blue' | 'teal' | 'purple';

export interface PageHeaderDefaults {
    /** Couleur de pastille appliquée quand l'en-tête ne passe pas `iconColor`. */
    iconColor?: PremiumPageIconColor;
}

const PageHeaderDefaultsContext = createContext<PageHeaderDefaults>({});

interface PageHeaderDefaultsProviderProps extends PageHeaderDefaults {
    children: ReactNode;
}

/**
 * Défauts des `PremiumPageHeader` d'une zone de l'application. Le back-office
 * super admin le fournit depuis le routeur pour que ses en-têtes prennent la
 * couleur de la charte sans la répéter page par page.
 */
export function PageHeaderDefaultsProvider({ children, iconColor }: PageHeaderDefaultsProviderProps) {
    return (
        <PageHeaderDefaultsContext.Provider value={{ iconColor }}>
            {children}
        </PageHeaderDefaultsContext.Provider>
    );
}

export function usePageHeaderDefaults(): PageHeaderDefaults {
    return useContext(PageHeaderDefaultsContext);
}
